import {
  SET_PACKAGES_ORIGINAL,
  SET_PACKAGES_FILTRADOS,
  SET_PACKAGES_DESTINATION_AND_ORIGIN,
  SET_PACKAGE_DETAILS,
} from './action-types';

const setPackagesOriginal = (payload) => ({ type: SET_PACKAGES_ORIGINAL, payload });
const setPackagesFiltrados = (payload) => ({ type: SET_PACKAGES_FILTRADOS, payload });
const setDestinationAndOrigin = (payload) => ({ type: SET_PACKAGES_DESTINATION_AND_ORIGIN, payload });
const setPackageDetail = (payload) => ({ type: SET_PACKAGE_DETAILS, payload });

export function savePackageDetails(data) {
  return function action(dispath) {
    return dispath(setPackageDetail(data));
  };
}

export function setPaqueteOriginal(data) {
  return function action(dispatch) {
    return dispatch(setPackagesOriginal(data));
  };
}
export function setPaqueteFiltrados(data) {
  return function action(dispatch) {
    return dispatch(setPackagesFiltrados(data));
  };
}

export function setSearchDestinationAndOrigin(data) {
  return function action(dispatch) {
    return dispatch(setDestinationAndOrigin({
      destino: data.destino,
      origen: data.origen,
    }));
  };
}
